






















import { Component, Prop, Vue, Watch } from "vue-property-decorator";
@Component
export default class SelectComponent extends Vue {
  @Prop()
  selectId!: string;
  @Prop({
    default: "100%"
  })
  width!: string;
  @Prop({
    default: "40px"
  })
  height!: string;
  @Prop({
    default: false
  })
  hasError!: boolean;
  @Prop({
    default: null
  })
  // デフォルトで選択されているoption
  initialValue?: any;
  @Prop({
    default: () => []
  })
  // 選択されたとき文字をグレー表示するoption
  grayColorValues?: string[];

  @Prop({
    default: false
  })
  isDisabled!: boolean;

  selectedOption: any = this.initialValue;

  @Watch("initialValue")
  onValueChange(value: any) {
    this.selectedOption = value;
  }

  @Watch("selectedOption")
  onChange(selectedOption: any) {
    this.$emit("onChange", selectedOption);
  }
}
